const initialState = {
  pagination: {
    documentsPerPage: 10,
    pageNumber: 1
  },
  filterInputs: {
    isAssigned: null,
    currentAnalyst: null,
    attendedByMe: false,
    prospectStatus: null,
    prospectSubStatus: null,
    purchaseDate: null
  },
  filters: []
};

export default {
  state: JSON.parse(JSON.stringify(initialState)),
  mutations: {
    SET_CURRENT_PAGINATION: (state, value) => {
      state.pagination = value;
    },
    SET_PAGINATION_DOC_PER_PAGE: (state, value) => {
      state.pagination.documentsPerPage = value;
    },
    SET_PAGINATION_PAGE_NUMBER: (state, value) => {
      state.pagination.pageNumber = value;
    },
    SET_FILTERS: (state, value) => {
      state.filters = value;
    },
    SET_FILTER_INPUTS: (state, value) => {
      state.filterInputs = value;
    }
  },
  actions: {
    setCurrentPagination({ commit }, paginationObj) {
      commit('SET_CURRENT_PAGINATION', paginationObj);
    },
    setPaginationDocumentsPerPage({ commit }, documentPerPage) {
      commit('SET_PAGINATION_DOC_PER_PAGE', documentPerPage);
    },
    setPaginationPageNumber({ commit }, pageNumber) {
      commit('SET_PAGINATION_PAGE_NUMBER', pageNumber);
    },
    setFilters({ commit }, filtersObject) {
      commit('SET_FILTERS', filtersObject);
    },
    setfilterInputs({ commit }, filterInputsObject) {
      commit('SET_FILTER_INPUTS', filterInputsObject);
    }
  }
};
